import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { BackButton } from './buttons/BackButton';

interface FullPageShellProps {
  children: ReactNode;
  onClose: () => void;
  className?: string;
  headerClassName?: string;
  mainClassName?: string;
}

export const FullPageShell = (props: FullPageShellProps) => (
  <div className={cn('fixed inset-0 min-h-screen overflow-y-auto bg-zinc-950 text-zinc-100', props.className)}>
    <header
      className={cn(
        'fixed left-0 right-0 top-0 flex h-12 items-center border-b border-white/[0.04] bg-zinc-950/70 px-4 backdrop-blur-xl',
        props.headerClassName,
      )}
    >
      <BackButton onClick={props.onClose} />
    </header>
    <main className={cn('mx-auto max-w-3xl px-4 pb-12 pt-20', props.mainClassName)}>
      {props.children}
    </main>
  </div>
);
